import React from 'react';
import CreateSession from 'containers/CreateSession';
import StagingPipelineArticle from 'components/organisms/StagingPipelineArticle';

export default () => (
  <CreateSession target='staging'>
    <StagingPipelineArticle/>
  </CreateSession>
);
